export const FE_SYSTEM_FINANCE_PATH = '/system/finance';

export const FE_SYSTEM_INVOICES_PATH = `${FE_SYSTEM_FINANCE_PATH}/invoices`;

export const FE_INVOICES_PATH = '/finance/invoices';

export const BE_SYSTEM_INVOICES_PATH = '/1/system/invoices';
